import { gql } from "@apollo/client";

export const submissionQuotas = gql`
    query submissionQuotas {
        submissionQuotas {
            regular {
                remaining
                remainingPercentage
                limitingQuotaType
                limitingWindow
                replenishAt
            }
            lensPlus {
                remaining
                remainingPercentage
                limitingQuotaType
                limitingWindow
                replenishAt
            }
        }
    }
`;
